// "Índice de Cronogramas" — painel com todos os projetos que já têm cronograma, equivalente à
// aba "Índice de Projetos" da planilha original: nome, cliente, datas, status e os totais
// (Horas Orçadas/% Concluído) já calculados da versão atual de cada um. Clicar na linha abre
// o cronograma daquele projeto.
import React from "react"
import Moment from "moment"
import { Container, Row, Col, Card, CardHeader, CardBody, Table } from "reactstrap"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import Loading from "components/Modals/Loading"
import api from "services/api"

// Datas vêm da API como meia-noite UTC — formatar em hora local mostraria o dia anterior pra
// quem está num fuso negativo (Brasil, UTC-3). Ver mesmo comentário em CronogramaConsole.js.
function fmtDate(d) {
  return d ? Moment.utc(d).format("DD/MM/YYYY") : "-"
}

class DashCronograma extends React.Component {
  state = {
    loading: true,
    rows: [],
  }

  componentDidMount() {
    this.load()
  }

  load = async () => {
    this.setState({ loading: true })
    try {
      const { data: rows } = await api.get("/cronogramaVersion/index")
      rows.sort((a, b) => a.projectName.localeCompare(b.projectName, "pt-BR"))
      this.setState({ rows, loading: false })
    } catch (err) {
      this.setState({ loading: false })
    }
  }

  goToProject = (projectId) => {
    this.props.history.push("/admin/cronogramaConsole/" + projectId)
  }

  render() {
    const { loading, rows } = this.state

    return (
      <>
        <SimpleHeader name="Índice de Cronogramas" items={[{ level: "nav", name: "Índice de Cronogramas" }]} />
        <Container className="mt--6" fluid>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Projetos com cronograma</h3>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Loading modalOpened={loading} />
                  ) : rows.length === 0 ? (
                    <p className="text-muted mb-0">Nenhum projeto tem cronograma ainda.</p>
                  ) : (
                    <Table responsive className="align-items-center">
                      <thead className="thead-light">
                        <tr>
                          <th>Projeto</th>
                          <th>Cliente</th>
                          <th>Data Início</th>
                          <th>Previsão de Término</th>
                          <th>Status Geral</th>
                          <th>Horas Orçadas</th>
                          <th>% Concluído</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row) => (
                          <tr
                            key={row.project}
                            style={{ cursor: "pointer" }}
                            onClick={() => this.goToProject(row.project)}
                          >
                            <td>{row.projectName}</td>
                            <td>{row.customerShortName}</td>
                            <td>{fmtDate(row.startDate)}</td>
                            <td>{fmtDate(row.previsaoTermino)}</td>
                            <td>{row.statusGeral}</td>
                            <td>{row.budgetedHours}</td>
                            <td>{Math.round(row.percentComplete)}%</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export default DashCronograma
